import { ChangeDetectionStrategy, Component, Inject, OnInit } from "@angular/core";
import { NewUiButton, NewUiProgressBarComponent } from "@ankaadia/ankaadia-shared-frontend";
import {
  DynamicDialogConfig as OldDynamicDialogConfig,
  DynamicDialogRef as OldDynamicDialogRef,
} from "primeng-v17/dynamicdialog";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { environment } from "../../../../environments/environment";
import { TranslateDirective } from "../../transloco/translate.directive";

@Component({
  selector: "new-ui-progress-dialog",
  templateUrl: "./new-ui-progress-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, NewUiButton, NewUiProgressBarComponent],
})
export class NewUiProgressDialogComponent implements OnInit {
  progressId: string;
  cancelable: boolean;
  initialMessage: string;

  constructor(
    @Inject(environment.newUI ? DynamicDialogRef : OldDynamicDialogRef)
    protected readonly dialogRef: OldDynamicDialogRef | DynamicDialogRef,
    @Inject(environment.newUI ? DynamicDialogConfig : OldDynamicDialogConfig)
    protected readonly config: OldDynamicDialogConfig | DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.progressId = this.config.data.progressId ?? "1";
    this.cancelable = this.config.data.cancelable ?? true;
    this.initialMessage = this.config.header ?? "...";
  }

  cancel(): void {
    this.dialogRef.close("cancelled");
  }
}
